import type { FormBlockMetadataById } from 'models/metadata/block.definition';
import { createContext } from 'react';

export const BlockMetadataContext = createContext<FormBlockMetadataById>({});
